
import { Header, UploadingFilesObjectForTable } from '@/models/main';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class FilesTable extends Vue {
  @Prop(Array) private readonly files: File[];

  private filesObjectsForTable: UploadingFilesObjectForTable[] = [];
  private filesHeaders: Header[] = [
    { text: 'Size', value: 'size', align: 'left' },
    { text: 'Name', value: 'name', align: 'left' },
    { text: 'Delete', value: 'delete', align: 'center' },
  ];

  @Watch('files', { immediate: true, deep: true })
  private watchToFiles() {
    if (this.files && this.files.length > 0 && this.filesObjectsForTable) {
      this.filesObjectsForTable = [];
      this.files.map(file => {
        this.filesObjectsForTable.push({
          name: file.name,
          size: file.size,
        });
      });
    }
  }
  private deleteFile(item: File): void {
    this.$emit('deleteFile', this.filesObjectsForTable.indexOf(item));
  }
}
